module.exports = __webpack_public_path__ + "sue-ellen-francisco.c44788607363e7ed0ed1.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/other/sue-ellen-francisco.ttf
// module id = ../../../../../src/assets/fonts/other/sue-ellen-francisco.ttf
// module chunks = styles